import SiteComponentReducers from 'yoda-site-components/lib/reducers';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';
import TrackOrderReducer from 'yoda-account-components/lib/reducers/TrackOrderReducer';
import MyListNameReducer from 'yoda-account-components/lib/reducers/MyListNameReducer';
import CancelOrderReducer from 'yoda-account-components/lib/reducers/CancelOrderReducer';
import UpdatePaymentReducer from 'yoda-account-components/lib/reducers/UpdatePaymentReducer';
import MyOrdersReducer from './MyOrdersReducer';
import OrderDetailsReducer from './OrderDetailsReducer';
import CurbsideReducer from './CurbsideReducer';

const rootReducer = {
    ...SiteComponentReducers,
    ordersHistory: MyOrdersReducer,
    orderDetails: OrderDetailsReducer,
    trackOrder: TrackOrderReducer,
    camNavMyList: MyListNameReducer,
    cancelOrderDetails: CancelOrderReducer,
    updatePaymentDetails: UpdatePaymentReducer,
    curbsideDetails: CurbsideReducer,
    webvitals: WebvitalsReducer,
};

export default rootReducer;
